/**
 * 적용 정책 검색 store
 * Ipv4, Ipv6
 *
 * @since 2018-06-05
 * @author kdydesign.kim
 */

import {
  CommonApiPrefix as cmnApiPrefix,
  SecutiryPolicyApiPrefix as objApiPrefix
} from 'utils'

// utils
import {pcDownloadFile} from '~/utils/files'
import {formatDate} from '~/utils/date'

// 방화벽 정책 적용 정책 검색 데이터
const initSearchApplyData = () => {
  return {
    zone: 1,
    protocol: 1,
    vlan: void 0,
    src: null,
    src_port: void 0,
    dst: null,
    dst_port: void 0,
    time: void 0,
    app: void 0
  }
}

// NAT 정책 적용 정책 검색 데이터
const initSearchNatApplyData = () => {
  return {
    inf: void 0,
    protocol: 1,
    src: null,
    src_port: void 0,
    dst: null,
    dst_port: void 0
  }
}

// 미적용 객체 검색 데이터
const initSearchAvaData = () => {
  return {
    date: 1
  }
}

// 미적용 정책 검색 데이터
const initSearchNotAvaData = () => {
  return {
    date: 1,
    recent_rule: 0
  }
}

export const state = () => ({
  protocolList: [],
  searchApplyDataList: [],
  searchApplyData: initSearchApplyData(),
  searchNotAvaData: initSearchNotAvaData(),
  searchNatApplyData: initSearchNatApplyData(),
  searchAvaDataList: [],
  searchAvaSelectDataList: [],
  searchAvaData: initSearchAvaData(),
  searchNotAvaDataList: [],
  selectApplySearchFilterData: void 0
})

export const mutations = {
  // store 초기화
  clearApplySearchStore (state) {
    state.protocolList = []
    state.searchApplyDataList = []
    state.searchNotAvaData = initSearchNotAvaData()
    state.searchApplyData = initSearchApplyData()
    state.searchNatApplyData = initSearchNatApplyData()
    state.searchAvaDataList = []
    state.searchAvaSelectDataList = []
    state.searchNotAvaDataList = []
    state.searchAvaData = initSearchAvaData()
    state.selectApplySearchFilterData = void 0
  },

  // 현재 시간 설정
  parseDateTime (state, {value}) {
    state.searchApplyData.time = formatDate(value, 'YYYY-MM-DD HH:mm:ss')
  },

  // 적용 정책 초기화
  resetSearchApplyData (state) {
    state.searchApplyDataList = []
    state.searchApplyData = initSearchApplyData()
    state.searchNotAvaData = initSearchNotAvaData()
    state.searchNatApplyData = initSearchNatApplyData()
    state.searchAvaDataList = []
    state.searchAvaSelectDataList = []
    state.searchNotAvaDataList = []
    state.searchAvaData = initSearchAvaData()
    state.selectApplySearchFilterData = void 0
  },

  // 적용 정책 미참조 객체 목록 초기화
  resetSearchAvaSelectData (state) {
    state.searchAvaSelectDataList = []
  },

  // 적용 정책 검색 - 프로토콜 조회
  getProtocolList (state, data) {
    const protocolList = []

    _.forEach(data, (value) => {
      protocolList.push({
        label: value.name,
        value: value.prtc_obj_id
      })
    })

    state.protocolList = Object.freeze(protocolList)
  },

  // 적용 정책 검색 (방화벽, NAT) - 미참조 객체 선택
  setSelectedAvaData (state, {data, ruleType}) {
    if (ruleType === 'fw') {
      const searchAvaSelectDataList = _.map(data.fw_rule, (rule) => {
        return _.assign(rule, {
          disableRule: 0
        })
      })

      state.searchAvaSelectDataList = Object.freeze(searchAvaSelectDataList)
    }

    if (ruleType === 'nat') {
      state.searchAvaSelectDataList = Object.freeze(data.nat_rule)
    }
  },

  // 적용 정책 검색 - 적용 정책 확인
  searchConfirmApplyPolicy (state, data) {
    state.searchApplyDataList = Object.freeze(data)
  },

  // 적용 정책 검색 - 미참조 객체 검색
  searchNotAvaApplyObject (state, data) {
    state.searchAvaDataList = Object.freeze(data)
  },

  // NAT 정책 - 적용 인터페이스 설정
  setFirstInterface (state, data) {
    state.searchNatApplyData.inf = _.get(data, [0, 'name'], '')
  },

  // 선택된 검색 데이터 선택
  selectApplySearchFilterData (state, data) {
    state.selectApplySearchFilterData = data
  },

  // 검색 결과 수정(정책 비활성화, 정책 삭제)
  updateSearchData (state, data) {
    const dataList = _.cloneDeep(state.searchNotAvaDataList)

    _.forEach(data, (value) => {
      const index = _.findIndex(dataList, {fw_rule_id: value.fw_rule_id})

      dataList.splice(index, 1)
    })

    state.searchNotAvaDataList = Object.freeze(dataList)
  },

  // 검색 결과 수정 벌크(정책 비활성화, 정책 삭제)
  updateBulkSearchData (state, data) {
    const dataList = _.cloneDeep(state.searchNotAvaDataList)

    _.forEach(data.items, (value) => {
      const index = _.findIndex(dataList, {fw_rule_id: value})

      dataList.splice(index, 1)
    })

    state.searchNotAvaDataList = Object.freeze(dataList)
  },

  // 선택된 정책 전체 변경
  changeAllDisableRule (state, {data, filterData}) {
    const searchAvaSelectDataList = _.map(state.searchAvaSelectDataList, (rule) => {
      // TAMS
      if (rule.fw_set_id === 0) {
        return rule
      }

      if (_.includes(filterData, rule)) {
        return _.assign(rule, {
          disableRule: data
        })
      }

      return rule
    })

    state.searchAvaSelectDataList = Object.freeze(searchAvaSelectDataList)
  },

  // 출발지/목적지 포트 초기화
  applyResetPort (state) {
    state.searchApplyData.src_port = void 0
    state.searchApplyData.dst_port = void 0
    state.searchNatApplyData.src_port = void 0
    state.searchNatApplyData.dst_port = void 0
  },

  // 적용 정책 검색 - 미참조 정책 검색
  searchNotAvaApplyPolicy (state, {result, ruleType}) {
    const searchNotAvaDataList = _.map(result, (rule) => {
      if (ruleType === 'fw') {
        return _.assign(rule, {
          disableRule: 0,
          fw_rule_id: Number(rule.fw_rule_id)
        })
      }

      if (ruleType === 'nat') {
        return _.assign(rule, {
          disableRule: 0,
          nat_rule_id: Number(rule.nat_rule_id)
        })
      }
    })

    state.searchNotAvaDataList = Object.freeze(searchNotAvaDataList)
  },

  // 검색 데이터 일괄 변경
  setSearchAllChangeDisable (state, {data, type, filterData, isTAMS}) {
    let key = void 0

    if (type === 'notAvaPolicy') {
      key = 'searchNotAvaDataList'
    }

    const stateData = _.map(state[key], (obj) => {
      // TAMS
      if (obj.fw_set_id === 0 && isTAMS) {
        return obj
      }

      if (_.includes(filterData, obj)) {
        return _.assign(obj, {
          disableRule: data
        })
      }

      return obj
    })

    state[key] = Object.freeze(stateData)
  }
}

export const actions = {
  // 현재 시간 설정
  setTime ({commit, rootState}) {
    commit('setTime', rootState)
  },

  // NAT 정책 - 적용 인터페이스 설정
  setFirstInterface ({commit, rootState}) {
    const natApplyInterface = rootState.securityPolicy.nat.natPolicySettings.natRules.natApplyInterface

    commit('setFirstInterface', natApplyInterface)
  },

  // 적용 정책 검색 - 프로토콜 조회
  async getProtocolList ({commit}) {
    const {code, result} = await this.$axios.$get(`api/op/service/protocols`, {loadingHide: false})

    if (code === 'ok') {
      commit('getProtocolList', result)
    }
  },

  // 적용 정책 검색 - 방화벽 정책 적용 정책 확인
  async searchConfirmApplyPolicy ({commit, state, rootState}) {
    const version = rootState.securityPolicy.firewall.firewallPolicySettings.fwRules.version
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/fw/${version}/apply-rules/search`, state.searchApplyData, {
      successAlert: false,
      loadingHide: false
    })

    if (code === 'ok') {
      commit('searchConfirmApplyPolicy', result)
      return result
    }
  },

  // 적용 정책 검색 - NAT 정책 적용 정책 확인
  async searchNatConfirmApplyPolicy ({commit, state, rootState}) {
    const natVerApiPrefix = rootState.securityPolicy.nat.natPolicySettings.natRules.natVerApiPrefix
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/${natVerApiPrefix}/apply-rules/search`, state.searchNatApplyData, {
      successAlert: false,
      loadingHide: false
    })

    if (code === 'ok') {
      commit('searchConfirmApplyPolicy', result)
      return result
    }
  },

  // 적용 정책 엑셀 다운로드 (비동기)
  async applySearchExcelDownload ({state, rootState}, {column}) {
    const version = rootState.securityPolicy.firewall.firewallPolicySettings.fwRules.version
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/fw/${version}/unuse-objects/search/days/${state.searchAvaData.date}/save?columns=(${column})`)

    if (code === 'async') {
      return result.id
    }
  },

  // 엑셀 파일 다운로드
  async excelFileDownload ({state}, {taskId}) {
    const {data, fileName} = await this.$axios.$file(`${cmnApiPrefix}/async/tasks/${taskId}/save`, {responseType: 'blob'})
    pcDownloadFile(data, fileName)
  },

  // 검색 결과 수정(정책 비활성화, 정책 삭제)
  updateSearchData ({state, commit}, {batchValue}) {
    commit('updateSearchData', batchValue)
  },

  // 검색 결과 수정 벌크(정책 비활성화, 정책 삭제)
  updateBulkSearchData ({state, commit}, {batchValue}) {
    commit('updateBulkSearchData', batchValue)
  },

  // 방화벽 적용 정책 검색 - 미참조 객체 검색
  async searchNotAvaApplyObject ({commit, state, rootState}) {
    const version = rootState.securityPolicy.firewall.firewallPolicySettings.fwRules.version
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/fw/${version}/unuse-objects/search/days/${state.searchAvaData.date}`, {
      successAlert: false,
      loadingHide: false
    })

    if (code === 'ok') {
      commit('searchNotAvaApplyObject', result)
      return result
    }
  },

  // NAT 적용 정책 검색 - 미참조 객체 검색
  async searchNatNotAvaApplyObject ({commit, state, rootState}) {
    const natVerApiPrefix = rootState.securityPolicy.nat.natPolicySettings.natRules.natVerApiPrefix
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/${natVerApiPrefix}/unuse-objects/search/days/${state.searchAvaData.date}`, {
      successAlert: false,
      loadingHide: false
    })

    if (code === 'ok') {
      commit('searchNotAvaApplyObject', result)
      return result
    }
  },

  // 적용 정책 검색 - 방화벽 정책 미참조 정책 검색
  async searchNotAvaApplyPolicy ({commit, state, rootState}) {
    const version = rootState.securityPolicy.firewall.firewallPolicySettings.fwRules.version
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/fw/${version}/unuse-rules/search`, state.searchNotAvaData, {
      successAlert: false,
      loadingHide: false
    })

    if (code === 'ok') {
      commit('searchNotAvaApplyPolicy', {result, ruleType: 'fw'})
      return result
    }
  },

  // 적용 정책 검색 - NAT 정책 미참조 정책 검색
  async searchNatNotAvaApplyPolicy ({commit, state, rootState}) {
    const natVerApiPrefix = rootState.securityPolicy.nat.natPolicySettings.natRules.natVerApiPrefix
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/${natVerApiPrefix}/unuse-rules/search`, state.searchNotAvaData, {
      successAlert: false,
      loadingHide: false
    })

    if (code === 'ok') {
      commit('searchNotAvaApplyPolicy', {result, ruleType: 'nat'})
      return result
    }
  },

  // 적용 정책 엑셀 다운로드 (비동기) - 미참조 정책
  async notAvaSearchExcelDownload ({state, rootState}, {filterData}) {
    const version = rootState.securityPolicy.firewall.firewallPolicySettings.fwRules.version
    const id = _.compact(_.map(filterData, 'fw_rule_id'))

    const {code, result} = await this.$axios.$post(`${objApiPrefix}/fw/${version}/unuse-rules/search/save`, {fw_rule_id: id})

    if (code === 'async') {
      return result.id
    }
  }
}

export const getters = {
  // NAT 정책 인터페이스 목록
  getApplyInterfaceList (state, getters, rootState) {
    const natApplyInterface = rootState.securityPolicy.nat.natPolicySettings.natRules.natApplyInterface

    return _.map(natApplyInterface, (inf) => {
      return {
        label: inf.name,
        value: inf.name
      }
    })
  }
}

export const strict = false
